var React = require('react');

function Line (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"20","width":"42","height":"2","key":0}),React.createElement("g",{"key":1}),React.createElement("g",{"key":2}),React.createElement("g",{"key":3}),React.createElement("g",{"key":4}),React.createElement("g",{"key":5}),React.createElement("g",{"key":6}),React.createElement("g",{"key":7}),React.createElement("g",{"key":8}),React.createElement("g",{"key":9}),React.createElement("g",{"key":10}),React.createElement("g",{"key":11}),React.createElement("g",{"key":12}),React.createElement("g",{"key":13}),React.createElement("g",{"key":14}),React.createElement("g",{"key":15})]);
}

Line.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 42 42","style":{"enableBackground":"new 0 0 42 42"},"xmlSpace":"preserve"};

module.exports = Line;

Line.default = Line;
